























import { Component, Prop, Vue } from 'vue-property-decorator'
import { updateResult } from '@/request/apis/common'
import { getSocket } from '@/socket.io'

@Component
export default class UpdateButton extends Vue {
  @Prop({ required: true }) jobId!: string
  @Prop({ required: true }) type!: string
  private loading: boolean = false
  private listener!: Function

  private async updateHandler () {
    this.loading = true
    try {
      this.addSocketListener()
      await updateResult(null, this.jobId, this.type).start()
    } catch (e) {
      console.log(e)
    }
  }

  private addSocketListener () {
    let socket = getSocket()
    if (!socket) return
    this.listener = (data: any) => {
      if (data.code === 0) {
        this.$emit('updateSuccess')
      }
      this.loading = false
    }
    socket.on('update_finish', this.listener)
  }

  private destroyed () {
    const socket = getSocket()
    if (!this.listener) return
    socket.off('update_finish', this.listener)
  }
}
